export const ACTION_TYPES = {
  INITIALISE_CATEGORIES: "init-categories",
  INITIALISE_PRODUCTS: "init-products",
  INITIALISE_CART: "initialise-cart",
  INITIALISE_WISHLIST: "initialise-wishlist",
  SET_IS_LOADING: "set-is-loading",
  SET_IS_ERROR: "set-is-error",
  INITIALIZE_RANGE_FILTER: "init-range-filter",
  INITIALIZE_CATEGORIES_FILTER: "init-categories-filter",
  SEARCH_KEY_CHANGE: "search-key-change",
  RANGE_FILTER_CHANGE: "range-filter-change",
  SELECTED_CATEGORIES_CHANGE: "selected-categories-change",
  RATING_FILTER_CHANGE: "rating-filter-change",
  SORT_FILTER_CHANGE: "sort-filter-change",
  CLEAR_ALL_FILTERS: "clear-all-filters",
  SELECTED_CATEGORY_CARD: "selected-category-card",
  ADD_TO_CART: "add-to-cart",
  REMOVE_FRM_CART: "remove-from-cart",
  UPDATE_QTY_CART: "update-qty-cart",
  ADD_TO_WISHLIST: "add-to-wishlist",
  REMOVE_FROM_WISHLIST: "remove-from-wishlist",
  CLEAR_CART: "clear-cart",
  CLEAR_WISHLIST: "clear-wishlist",
  VIEW_BESTSELLERS: "view-bestsellers",
  SET_ORDER_DETAILS: "set-order-details",
  SET_ORDER_ADDRESS: "set-order-address",
  SET_PRODUCTS_PAGE_NUM: "set-products-page-num",
  RESET_PRODUCTS_PAGE_NUM: "reset-products-page-num",
};
